module.exports = __webpack_public_path__ + "img/abx.80f06bf9.png";